import { ContactExportRequest, ContactSelectType } from "../schema/contacts";

interface ExportSelection {
	selectType: ContactSelectType;
	selectedItems: number[];
	filter?: Record<string, unknown>;
	query?: string;
	semanticSearchProspects?: string;
}

/**
 * Decides what an Export click covers.
 *
 * Export-only, and deliberately **not** part of the shared `getSelectionPayload` — that one feeds
 * six consumers including "Add to blacklist", where treating an empty selection as "everything"
 * would blacklist the whole filtered set.
 *
 * The footer Export button is enabled with no rows ticked (it sits next to the total row count, so
 * it reads as "export this table"). It used to send `{ CURRENT_PAGE, ids: [] }`, which the API
 * rejects with 400 — the export simply failed, silently on Chromium (PREC-3953). An empty
 * selection therefore means "everything matching the current filter and search", which is what the
 * button's position implies.
 */
export function buildExportPayload({
	selectType,
	selectedItems,
	filter,
	query,
	semanticSearchProspects,
}: ExportSelection): ContactExportRequest {
	const coversEverything = selectType === ContactSelectType.ALL || selectedItems.length === 0;

	if (coversEverything) {
		return {
			selectType: ContactSelectType.ALL,
			...(filter && Object.keys(filter).length > 0 && { filter: JSON.stringify(filter) }),
			...(query && { searchValue: query }),
			...(semanticSearchProspects && { semanticSearchProspects }),
		};
	}

	return {
		selectType: ContactSelectType.CURRENT_PAGE,
		ids: selectedItems,
	};
}
